'use strict';

angular.module('docketbook').
factory('splitListInterface', function($timeout) {
  function Factory ($scope, $stateParams) {
    this.$scope = $scope;
    this.$stateParams = $stateParams;
  }

  // Open detail pane - slide from right
  var slideListDetailOpen = function() {
    if ( $(".contentSplitList").width() > 100 ) {
      $(".contentSplitList").animate({
        width: "40%"
      }, 800);
    }
    $(".splitableContentContainer").animate({
      width: "100%"
    }, 800, function() {
      $(".splitableContentContainer").addClass('showDetail');
    });

    $(".contentSplitList").addClass("collapsed");

    // Currently not used anymore -- old filter and control buttons
    $(".splitableContentControls").fadeIn();
    $(".contentSplitList .contentFilters").fadeOut(function() {
      $(".contentSplitList .sidebarControlsHorizontal").fadeIn();
    });
  }

  var slideTableListDetailOpen = function() {
    var windowWidth = $(window).width();
    /*if ( $(".desktopSplitListDetailOuter").width() < (.5 * windowWidth) ) {*/
    if ( windowWidth >= 1400 ) {
      $(".desktopSplitListTableOuter").css({ display: 'block' })
      $(".desktopSplitListDetailOuter").css({ display: 'block' })

      //$(".desktopSplitListTableOuter").css({'width':'50%'});
      //$(".desktopSplitListDetailOuter").css({'width':'50%'});
    } else {
      $(".desktopSplitListTableOuter").css({ display: 'none' })
      $(".desktopSplitListDetailOuter").css({ display: 'block' })
      //$(".desktopSplitListTableOuter").hide();
      //$(".desktopSplitListDetailOuter").css({'width':'100%'});
    }
  }

  var slideTableListDetailClosed = function() {
    /*$(".desktopSplitListTableOuter").show();
    $(".desktopSplitListTableOuter").css({'width':'100%'});
    $(".desktopSplitListDetailOuter").css({'width':'0px'});*/

    $(".desktopSplitListTableOuter").css({ display: 'block' })
    $(".desktopSplitListDetailOuter").css({ display: 'none' });
  }

  // Close detail pane - slide to right
  var slideListDetailClosed = function(cb) {
    if ( $(".contentSplitList").hasClass('collapsed') ) {
      $(".splitableContentContainer").animate({
        width: "200%"
      }, 800);

      setTimeout(function() {
        $(".contentSplitList").removeClass('collapsed');
        $(".contentSplitList").animate({
          width: "50%"
        }, 800, function() {
          cb();
        });
      }, 200);
      $(".contentSplitList .sidebarControlsHorizontal").fadeOut(function() {
        $(".contentSplitList .contentFilters").fadeIn();
      });
    }
  }

  Factory.prototype.slideTableListDetailOpen = slideTableListDetailOpen;
  Factory.prototype.slideTableListDetailClosed = slideTableListDetailClosed;

  // Minimise item list bar
  Factory.prototype.minimiseItemList = function() {
    var width = $(".contentSplitList").width();

    if ( width > 100 ) {
      // Minimise list to tiny width
      $(".contentSplitList h1").fadeOut();
      $(".contentSplitList .contentFilters").fadeOut();
      $(".contentSplitList .contentList").fadeOut();
      $(".contentSplitList .splitableContentControls .leftArrow").fadeOut();
      $(".contentSplitList .sidebarControlsHorizontal").fadeOut(function() {
        $(".contentSplitList .sidebarControlsVertical").fadeIn();
      });
      $(".contentSplitList").animate({
        width: '80px'
      }, 800);
    }
  }

  Factory.prototype.maximiseItemList = function() {
    var width = $(".contentSplitList").width();

    var outerScope = this.$scope;
    var outerStateParams = this.$stateParams;

    if ( width < 100 ) {
      $timeout(function(){
        $(".contentSplitList h1").fadeIn();
        $(".contentSplitList .contentList").fadeIn();
        $(".contentSplitList .splitableContentControls .leftArrow").fadeIn();
      }, 400);
      $(".contentSplitList").animate({
        width: '250px'
      }, 800);
    } else {
      slideListDetailClosed(function() {
        outerScope.itemEdit = null;
        outerStateParams.active = null;
        outerStateParams.activeByIndex = null;
      });
    }
  }

  // Ensure that content list is at normal list/detail size
  Factory.prototype.ensureListOpen = function(cb) {
    var width = $(".contentSplitList").width();
    if ( width < 100 ) {
      $timeout(function(){
        $(".contentSplitList h1").fadeIn();
        $(".contentSplitList .contentList").fadeIn();
        $(".contentSplitList .splitableContentControls .leftArrow").fadeIn();
      }, 400);

      $(".contentSplitList").animate({
        width: '250px'
      }, 800, function() {
        if ( cb ) {
          cb();
        }
      });
    } else {
      if ( cb ) {
        cb();
      }
    }
  }

  // Expand detail content of list item on angular trigger
  Factory.prototype.openListItemDetail = function(cb) {
    if ( $(".contentSplitList .contentList .actualListItem") == null || $(".contentSplitList .contentList .actualListItem").width() == null || $(".contentSplitList .contentList .actualListItem").width() > 0 ) {
      $timeout(function() {
        slideListDetailOpen();
      },200);
    }
    if ( cb ) {
      cb();
    }
  }

  // Open detail when in mobile mode
  Factory.prototype.openListMobileDetail = function(item, cb) {
    this.$scope.itemEdit = item;
    this.$scope.currentTab = "General";
    $(".mobileTabBar").scrollLeft(0);
    $(".mobileFooterBar").addClass('hidden-xs');
  }

  // Close detail when in mobile mode
  Factory.prototype.closeListMobileDetail = function() {
    if ( this.$scope.mode != 'desktop' ) {
      $(".mobileFooterBar").removeClass('hidden-xs');
    }
  }

  // Toggle expand/contract of mobile filters in mobile footer bar
  Factory.prototype.toggleMobileFilters = function() {
    $("#mobileFilters").toggle(400);
  }

  // Show list item control buttons on angular swipe left gesture
  Factory.prototype.swipeListItem = function(idNumber) {
    var controlsWidth = $("#listItemControls" + idNumber).width();
    var translateX = "-" + (controlsWidth) + "px";

    $("#listItem" + idNumber + " .customListRow").animate({
      left: translateX
    }, 600, function() {

    });
  }

  // Close list item control buttons on angular swipe right gesture
  Factory.prototype.swipeListItemClose = function(idNumber) {
    $("#listItem" + idNumber + " .customListRow").animate({
      left: "0px"
    }, 600, function() {

    });
  }

  // Change the value of a filter
  Factory.prototype.changeFilter = function(filterName, newValue) {
    this.$scope.filters[filterName] = newValue;
  }

  // Toggle value of AND filter
  Factory.prototype.toggleAndFilter = function(filterName, filterOption) {
    if ( filterOption == 'all' ) {
      // special - if any other filters on filterName are selected, set only all to true
      var keys = Object.keys(this.$scope.filters[filterName]);
      var trueCount = 0;
      for ( var key in this.$scope.filters[filterName] ) {
        if ( this.$scope.filters[filterName][key] == true ) {
          this.$scope.filters[filterName][key] = false;
          trueCount += 1;
        }
      }
      if ( trueCount > 0 ) {
        this.$scope.filters[filterName]['all'] = true;
      } else {
        this.$scope.filters[filterName]['all'] = false;
      }
    } else {
      this.$scope.filters[filterName][filterOption] = !this.$scope.filters[filterName][filterOption];

      // update all status
      var trueCount = 0;
      for ( var key in this.$scope.filters[filterName] ) {
        if ( this.$scope.filters[filterName][key] == true ) {
          trueCount += 1;
        }
      }
      if ( trueCount > 0 ) {
        this.$scope.filters[filterName]['all'] = false;
      } else {
        this.$scope.filters[filterName]['all'] = true;
      }
    }
  }

  Factory.prototype.prepareFormFields = function() {
    $("form input").each(function() {
			$(this).removeClass('ng-dirty');
			$(this).removeClass('ng-touched');
			$(this).removeClass('ng-invalid');
		});
  }

  return Factory;
});



// WEBPACK FOOTER //
// ./src/factories/splitListInterface.js